import React, { Component } from "react";
import Login from "./Login/Login";
import "./Login/Login.css";
import { createBrowserHistory } from "history";
import axios from "axios";
import * as appConst from "./Common/constants";
import { Growl } from "primereact/growl";
import Main from "./Common/Main";

require("dotenv").config();
const history = createBrowserHistory();

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loginPage: [],
      list: [],
      mode: "LoginScreen",
      title: ""
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleLogoffClick = this.handleLogoffClick.bind(this);
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/center/getName"
      )
      .then(response => {
        this.setState({
          title: response.data
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    if (this.state.mode === "LoginScreen") {
      return (
        <div className="LoginScreen">
          <Login onClick={this.handleClick} title={this.state.title} />{" "}
          <Growl ref={el => (this.growl = el)} />
        </div>
      );
    } else {
      return (
        <Main
          handleLogoff={this.handleLogoffClick.bind(this)}
          title={this.state.title}
        />
      );
      // return <Menu />;
    }
  }

  handleLogoffClick() {
    this.setState({
      mode: "LoginScreen"
    });
  }

  handleClick(username, pword) {
    if (username !== "" && pword !== "") {
      var payload = {
        username: username,
        password: pword
      };

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) + "/login/validate/",
          payload
        )
        .then(res => {
          if (res.status === 200) {
            history.push("/PalCare");
            this.setState({
              mode: "Main"
            });
          } else if (res.status === 205) {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Account Expired !!"
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Invalid Credentials !!"
            });
          }
        });
    } else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Enter Credentials !!"
      });
    }
  }
}
const style = {
  margin: 15
};
export default App;
